(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["djirone-footer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('djirone-footer')) {
    customElements.define('djirone-footer', class extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(max-width: 749px)');
        this.updateColumns = () => {
          this.querySelectorAll('details').forEach((column) => {
            column.open = !this.media.matches || Boolean(column.querySelector('.dj-footer__status'));
            column.querySelector('summary').tabIndex = this.media.matches ? 0 : -1;
          });
        };
        this.updateColumns();
        this.media.addEventListener('change', this.updateColumns);
      }
      disconnectedCallback() {
        this.media.removeEventListener('change', this.updateColumns);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
